"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "2f1c179",
    "raw": "v2.18.0",
    "semverString": "2.18.0"
};
//# sourceMappingURL=version.js.map